/** Bump to ask every user to accept the Agents beta terms again. */
export const AGENT_BETA_TERMS_VERSION = 1;
